import { render } from "./LineFaceTraining.vue?vue&type=template&id=53b1fb0d&scoped=true&ts=true"
import script from "./LineFaceTraining.vue?vue&type=script&lang=ts"
export * from "./LineFaceTraining.vue?vue&type=script&lang=ts"

import "./LineFaceTraining.vue?vue&type=style&index=0&id=53b1fb0d&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53b1fb0d"]])

export default __exports__